export default __webpack_public_path__ + "6f7720e8a39a461516ac0d258a2bc14a.jpg";